import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/video-to-prompt/page.tsx");
